import { AppBar } from "@mui/material";
import { styled } from "@mui/material/styles";
import { wpiTheme } from "./wpiTheme";

export const CustomAppBar = styled(AppBar)(({ theme }) => ({
    'background-color': wpiTheme.color,
}))